import { accountActivityUrl } from "./endpoints.js";
const accountActivityCacheKey = ({
  accountId,
  accountIdType
}) => [accountActivityUrl, { accountId, accountIdType }];
export {
  accountActivityCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
